import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "antd/dist/reset.css";

// Suppress Ant Design warning
console.warn = (message: string) => {
  if (message.includes("[antd: compatible]")) return;
  console.error(message);
};

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
